import { ref, watch, onMounted, nextTick, computed } from 'vue';
import { useStore } from 'vuex';
export default {
  name: 'creditsIcon',
  props: {
    isPlayAnimation: {
      type: Boolean,
      default: null
    }
  },
  setup(props) {
    const store = useStore();
    const root = ref(null);
    const isPlay = ref(false);
    // console.log('setup', root.value, showAnimation.value, props.isPlayAnimation)

    // 是否要显示动画 ( 纯判断显示 )
    const showAnimation = computed(() => store.state.animationPlayControl.creditIcon === 0);
    if (showAnimation.value) {
      // 由外部控制播放时机
      const isPlayAnimation = computed(() => props.isPlayAnimation);
      const watcherPlayAnimation = watch(isPlayAnimation, (newVal, oldVal) => {
        if (newVal) {
          // console.log('watcherPlayAnimation', root.value, oldVal, newVal, showAnimation.value)
          if (showAnimation.value) {
            store.commit('setAnimationPlayControl', {
              creditIcon: 1
            });
            isPlay.value = true;
          }
          watcherPlayAnimation(); // unwatch
        }
      });
    }

    onMounted(() => {
      // console.log('onMounted', root.value, showAnimation.value, props.isPlayAnimation)
      if (showAnimation.value && props.isPlayAnimation !== false) {
        // 没有 props, 或是尚未到播放时机
        store.commit('setAnimationPlayControl', {
          creditIcon: 1
        });
        nextTick(() => {
          isPlay.value = true;
        });
      }
    });
    return {
      root,
      isPlay
    };
  }
};